import React, { Component } from 'react';

export class ExternalLayout extends Component {
  static displayName = ExternalLayout.name;

  render () {
    return (
        <div className="container-fluid px-1 py-5 mx-auto bg-header-eni"
            style={{
                backgroundImage: "url('./img/bandeau-eadl.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
            <div className="row d-flex justify-content-center">
                <div className="text-center" style={{ color: 'white' }}>
                    <div className="row">
                        <h1>ENI Ecole Informatique</h1>
                    </div>
                    <div className="row">
                        <h3>Rejoindre l'aventure ENI</h3>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}
